import { endsWith } from 'lodash';

const taboolaEmailSuffix = '@taboola.com';

export default ({ username }) => endsWith(username, taboolaEmailSuffix);
